"use strict";

exports.__esModule = true;
exports.DashboardEditor = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _reactDebounceInput = require("react-debounce-input");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _Core = require("../../Core");
var _Theme = require("../../Theme");
var _Device = require("../../Device");
var _DashboardTagContext = require("../DashboardTagContext");
var _Widgets = require("../../Widgets");
var _userActionsContext = require("../../UserActions/userActionsContext");
var _API = require("../../API");
var _validateName = require("../CreateDashboardWizard/validateName");
var _class, _DashboardEditor;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var DashboardEditorContainer = _styledComponents["default"].div.withConfig({
  displayName: "DashboardEditor__DashboardEditorContainer",
  componentId: "sc-4bdcsl-0"
})(["& .", "{padding:0 1rem;height:40px;border-bottom:solid 1px rgba(0,0,0,0.2);color:", ";background:", ";.", "{background-color:", ";}.", "[aria-selected=\"true\"],.", ":not([aria-disabled=\"true\"]):hover{color:", ";}}"], _core.Classes.TAB_LIST, (0, _Theme.val)("ToolbarTextColor"), (0, _Theme.val)("ToolbarBackground"), _core.Classes.TAB_INDICATOR, (0, _Theme.val)("tabIndicatorColor"), _core.Classes.TAB, _core.Classes.TAB, (0, _Theme.val)("tabIndicatorColor"));

/**
 * An interface for editing dashboards
 */
var DashboardEditor = exports.DashboardEditor = (0, _Core.withTranslator)(_class = (0, _Widgets.withWidgetsContext)(_class = (0, _userActionsContext.withUserActionsContext)(_class = (_DashboardEditor = /*#__PURE__*/function (_Component) {
  function DashboardEditor() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      value: _this.props.value,
      selectedTabId: "editor"
    };
    _this.handleTabChange = function (selectedTabId) {
      return _this.setState({
        selectedTabId: selectedTabId
      });
    };
    _this.handleLayoutChange = function (value) {
      _this.setState({
        value: value
      });
    };
    _this.checkIfValid = function (name) {
      var _this$props = _this.props,
        translator = _this$props.translator,
        dashboardCollection = _this$props.dashboardCollection;
      var translate = translator.translate;
      if (_this.props.value.name === name) {
        _this.setState(Object.assign({}, _this.state, {
          invalidText: ""
        }));
        return;
      }
      (0, _validateName.validateName)(name, dashboardCollection, translate).then(function (invalidText) {
        return _this.setState(Object.assign({}, _this.state, {
          invalidText: invalidText
        }));
      });
    };
    return _this;
  }
  _inheritsLoose(DashboardEditor, _Component);
  DashboardEditor.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var value = _ref.value;
    if (value === prevState.value) {
      return null;
    }
    return {
      value: value
    };
  };
  var _proto = DashboardEditor.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props2 = this.props,
      widgets = _this$props2.widgets,
      onSubmit = _this$props2.onSubmit,
      onDelete = _this$props2.onDelete,
      onDuplicate = _this$props2.onDuplicate,
      translator = _this$props2.translator,
      userActions = _this$props2.userActions;
    var translate = translator.translate;
    var _this$state = this.state,
      value = _this$state.value,
      selectedTabId = _this$state.selectedTabId,
      invalidText = _this$state.invalidText;
    return /*#__PURE__*/_react["default"].createElement(_Core.UndoController, {
      value: value,
      onChange: this.handleLayoutChange
    }, function (undoController) {
      return /*#__PURE__*/_react["default"].createElement(_Core.UndoContext.Provider, {
        value: undoController
      }, /*#__PURE__*/_react["default"].createElement(DashboardEditorContainer, {
        "data-testid": "DashboardEditor.Container"
      }, /*#__PURE__*/_react["default"].createElement(_DashboardTagContext.DashboardTagContext.Consumer, null, function (_ref2) {
        var _undoController$state, _undoController$state2;
        var loading = _ref2.loading,
          deviceTags = _ref2.data;
        if (loading) {
          return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
        }
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Core.Toolbar, null, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            width: "100%"
          }
        }, /*#__PURE__*/_react["default"].createElement(_core.Tabs, {
          id: "DashboardEditorTabs",
          selectedTabId: selectedTabId,
          onChange: _this2.handleTabChange
        }, /*#__PURE__*/_react["default"].createElement(_core.Tab, {
          id: "editor",
          title: "Editor"
        }), /*#__PURE__*/_react["default"].createElement(_core.Tab, {
          id: "details",
          title: "Details"
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: _core.Classes.FLEX_EXPANDER
        }), /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
          style: {
            marginLeft: "1rem"
          }
        }, /*#__PURE__*/_react["default"].createElement(_Core.ActionButton, {
          "data-testid": "DashboardEditor.saveButton",
          icon: _icons.IconNames.FLOPPY_DISK,
          intent: _core.Intent.PRIMARY,
          text: translate("DashboardEditor.saveButton.text", "Save"),
          successText: translate("DashboardEditor.saveButton.successText", "Saved"),
          onClick: function onClick() {
            return onSubmit(undoController.state);
          },
          disabled: !!invalidText || ((_undoController$state = undoController.state.element.props) == null || (_undoController$state = _undoController$state.rolesVisibility) == null ? void 0 : _undoController$state.length) === 0 || ((_undoController$state2 = undoController.state.element.props) == null || (_undoController$state2 = _undoController$state2.usersVisibility) == null ? void 0 : _undoController$state2.length) === 0
        }), onDuplicate && /*#__PURE__*/_react["default"].createElement(_Core.ActionButton, {
          "data-testid": "DashboardEditor.duplicateButton",
          icon: _icons.IconNames.DUPLICATE,
          text: translate("DashboardEditor.duplicateButton.text", "Duplicate"),
          onClick: function onClick() {
            return onDuplicate(undoController.state);
          },
          minimal: true
        }), onDelete && /*#__PURE__*/_react["default"].createElement(_Core.ActionButton, {
          "data-testid": "DashboardEditor.deleteButton",
          icon: _icons.IconNames.TRASH,
          intent: _core.Intent.DANGER,
          text: translate("DashboardEditor.deleteButton.text", "Delete"),
          confirm: /*#__PURE__*/_react["default"].createElement(_Core.Text, null, translate("DashboardEditor.deleteButton.confirmText", "Are you sure you want to delete this dashboard? This action cannot be undone.")),
          onClick: function onClick() {
            return onDelete(undoController.state);
          },
          minimal: true
        }))))), selectedTabId === "details" && /*#__PURE__*/_react["default"].createElement(_Core.Content, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
          label: translate("DashboardEditor.nameInput.label", "Dashboard Name"),
          intent: invalidText ? _core.Intent.DANGER : undefined,
          helperText: invalidText || translate("DashboardEditor.nameInput.helperText", "A descriptive name for the dashboard.")
        }, /*#__PURE__*/_react["default"].createElement(_reactDebounceInput.DebounceInput, {
          element: _core.InputGroup,
          debounceTimeout: 300,
          style: {
            width: 300,
            border: invalidText ? "solid red 2px" : undefined
          },
          "data-testid": "DashboardEditor.nameInput",
          placeholder: translate("DashboardEditor.nameInput.placeholder", "Untitled Dashboard"),
          maxLength: 35,
          onChange: function onChange(e) {
            undoController.setState({
              name: e.target.value
            });
            _this2.checkIfValid(e.target.value);
          },
          value: undoController.state.name
        })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
          label: translate("DashboardEditor.descriptionInput.label", "Description"),
          helperText: translate("DashboardEditor.descriptionInput.helperText", "A short description of the dashboard.")
        }, /*#__PURE__*/_react["default"].createElement(_core.TextArea, {
          className: _core.Classes.FILL,
          "data-testid": "DashboardEditor.descriptionInput",
          style: {
            width: 500
          },
          maxLength: 140,
          rows: 4,
          onChange: function onChange(e) {
            var value = e.target.value;
            undoController.setState(function (state) {
              return {
                element: Object.assign({}, state.element, {
                  props: Object.assign({}, state.element.props, {
                    description: value
                  })
                })
              };
            });
          },
          value: undoController.state.element.props.description || ""
        })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
          name: "tags",
          label: translate("DashboardEditor.tagInput.tags", "Dashboard Tags"),
          helperText: translate("DashboardEditor.tagInput.helperText", "Separate multiple tags with comma")
        }, /*#__PURE__*/_react["default"].createElement(_Device.DeviceTagSelector, {
          shouldAddItemWhenNotInList: function shouldAddItemWhenNotInList(value) {
            return !deviceTags.find(function (tag) {
              return tag === value;
            });
          },
          multiple: true,
          items: deviceTags,
          onSelect: function onSelect(selectedTags) {
            undoController.setState({
              tags: selectedTags
            });
          },
          selected: undoController.state.tags || [],
          rightIcon: _icons.IconNames.CARET_DOWN,
          minimal: true
        }))), selectedTabId === "editor" && /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.LayoutEditor, {
          widgets: widgets.dashboardWidgets,
          value: undoController.state,
          onChange: undoController.setState,
          userActions: userActions
        }));
      })));
    });
  };
  return DashboardEditor;
}(_react.Component), _DashboardEditor.defaultProps = {
  translator: undefined,
  widgets: undefined,
  userActions: undefined
}, _DashboardEditor)) || _class) || _class) || _class;